
import { isEmpty } from '@/utils/helpers'
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class EmojiPicker extends Vue {
  htmlText = ''

  @Prop({ type: String, default: '' })
  content!: string

  @Prop(Array)
  dataList!: Array<string>

  mounted() {
    this.hitHighLight(this.content, this.dataList)
  }

  hitHighLight(content: string, dataList: Array<string>) {
    if (isEmpty(content)) {
      return ''
    }

    // 
    let mergeStr = content
    for (let i = 0, j = dataList.length; i < j; i++) {
      const emojiText = dataList[i]
      const reg = new RegExp(`\\[${emojiText}\\]`, 'g')
      if (reg.test(mergeStr)) {
        const imgSrc = require(`@/assets/emoji/smiley_${i}.png`)
        mergeStr = mergeStr.replace(reg, `<img src=${imgSrc} align="middle">`)
      }
    }
    
    this.htmlText = mergeStr
  }
}
